import { Typography } from "antd";

const { Text } = Typography;

function LoyaltySection({ title, children, className = "", spaced = false, bodyClassName = "", action = null }) {
  return (
    <div className={["loyalty-section", spaced && "loyalty-section--spaced", className].filter(Boolean).join(" ")}>
      <div
        className={["loyalty-section-header", action && "loyalty-section-header--with-action"]
          .filter(Boolean)
          .join(" ")}
      >
        <Text strong>{title}</Text>
        {action ? <div className="loyalty-section-header-action">{action}</div> : null}
      </div>
      <div className={["loyalty-section-body", bodyClassName].filter(Boolean).join(" ")}>{children}</div>
    </div>
  );
}

export default LoyaltySection;
